import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faCalendar } from '@fortawesome/pro-duotone-svg-icons';
import { Enum, EnumType } from 'ts-jenum';

@Enum<AppointmentPurpose>('name')
export class AppointmentPurpose extends EnumType<AppointmentPurpose>() {
   static readonly SCHEDULER = new AppointmentPurpose('SCHEDULER', faCalendar, 'samwin.appointment_dialog.titlebar.title', '');

   private constructor(public name: string, public titlebarIcon: IconDefinition, public titlebarText: string, public infoText: string) {
      super();
   }
}
